/* eslint-disable prefer-const */
/* eslint-disable import/prefer-default-export */
import { createStore } from 'vuex';
import {
  SystemAuthRemoveTokenDel,
  SystemPermissionGetBUList,
  GetBusinessLicense,
} from '@/js/api/system';
import { showMsg } from '@/js/basic';
// eslint-disable-next-line import/no-cycle
import dashboard from './modules/dashboard';
import system from './modules/system';
import member from './modules/member';
import controlItem from './modules/controlItem';
import settingManagement from './modules/settingManagement';
import ocap from './modules/ocap';
import alertList from './modules/alertList';
import wip from './modules/wip';

export const store = createStore({
  state: {
    user: {
      name: '',
      account: '',
      id: '',
      code: '',
    },

    /** 存放使用者選用的語系 */
    lang: null,

    /** 頁面載入中 */
    pageLoading: false,

    /** 存取欲換介面名稱 => 用於顯示 Loading */
    LoadingName: '',

    /** 當前的介面名稱 */
    nowBUName: '',

    /** 當前的介面 Key */
    nowBUKey: '',

    userBUlist: [],

    /** 廠區角色允許的權限清單 */
    buRolePermission: {},

    /** 是否啟用其他功能 */
    userPermissionSwitch: {},

    license: {},
  },

  mutations: {
    /**
     * 切換語系設定
     * @param {*} state
     * @param {*} value
     */
    setLang(state, value) {
      state.lang = value;
    },

    /**
     * 建立全域使用者變數
     * @param {*} state
     * @param {*} userInfo
     */
    setUser(state, userInfo) {
      state.user.name = userInfo.name;
      state.user.account = userInfo.account;
      state.user.id = userInfo.id;
      state.user.emp_code = userInfo.emp_code;
    },

    /**
     * 切換 系統 / 廠區 顯示F
     * @param {*} state
     * @param {*} value
     */
    setNowBU(state, value) {
      state.nowBUName = value?.re_name ?? '';
      state.nowBUKey = value?.sys_bu ?? '';
    },

    setLoadingName(state, value) {
      state.LoadingName = value.re_name;
    },

    /**
     * 廠區下拉選單設值
     * @param {*} state
     * @param {*} value
     */
    setUserBUlist(state, value) {
      // console.log('setUserBUlist');
      // console.log(value);
      state.userBUlist = value;
    },

    setPageLoading(state, value) {
      state.pageLoading = value;
    },

    /** 廠區角色允許的權限清單設值 */
    setBuRolePermission(state, value) {
      state.buRolePermission = value;
    },

    /** 其他功能 設值 */
    setUserPermissionSwitch(state, permissionInfo) {
      /** 啟用編輯功能 */
      state.userPermissionSwitch.dataTypePermission = permissionInfo.dataTypePermission;

      /** 啟用隱藏功能 */
      state.userPermissionSwitch.noisePointPermission = permissionInfo.noisePointPermission;
    },

    /** 建立授權物件 */
    setLicense(state, value) {
      state.license = value;
    },
  },

  actions: {
    /** 防止 refresh 時 state 中的 BU資料清掉 */
    getBuDatafromSessionStorage() {
      if (sessionStorage.getItem('nowShowing')) {
        let nowShowData = JSON.parse(sessionStorage.getItem('nowShowing'));

        // 把 目前介面 存入
        store.commit('setNowBU', nowShowData);
      }
    },

    /** 取得 BU 列表 */
    getBUSysList({ msg }) {
      let getData = [];
      SystemPermissionGetBUList()
        .then((res) => {
          const isAdmin = sessionStorage.getItem('is_admin') === 'true';
          if (res.data.success) {
            if (res.data.result.length) {
              res.data.result.forEach((item) => {
                getData.push({ re_name: item.re_name, sys_bu: item.sys_bu });
              });
            } else if (!res.data.result.length && !isAdmin) {
              showMsg(`${res.data.msg}`, 'error', 3000);
              SystemAuthRemoveTokenDel().then((result) => {
                // console.log(res);
                if (result.data.success) {
                  localStorage.clear();

                  // 從sessionStorage移除之前存的所有資料
                  sessionStorage.clear();

                  // 使用者資料更新
                  this.$store.commit('setUser', {
                    name: '',
                    account: '',
                    id: '',
                  });
                }
              });
            }

            if (isAdmin) {
              getData.push({ re_name: 'System', sys_bu: '.' });
            }
          } else {
            // 沒成功 => 把目前顯示介面資料清空
            store.commit('setNowBU', { re_name: '', sys_bu: '' });
            showMsg(`${msg}${res.data.msg}`, 'error', 3000);
          }

          // 把 BU list 存入
          store.commit('setUserBUlist', getData);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /** 切換讀取 BU / System */
    readBUSys(uuid) {
      console.log(uuid);
      // 這邊要接 API 取得廠區或是 Sys 的共用資訊
    },

    setUserInfo() {
      if (sessionStorage.getItem('token')) {
        let data = {
          name: sessionStorage.getItem('user_name'),
          account: sessionStorage.getItem('account'),
          id: sessionStorage.getItem('user_id'),
          emp_code: sessionStorage.getItem('emp_code'),
        };
        store.commit('setUser', data);
      }
    },

    // eslint-disable-next-line consistent-return
    async LicenseJudge({ state }, { str, msg }) {
      // console.log(str);
      // console.log(state.state.license);
      if (Object.keys(state.license).length !== 0) {
        const licenseJudge = state.license.module.find((item) => {
          return item.module === str;
        });
        if (licenseJudge && !licenseJudge.usable) {
          if (msg !== undefined) {
            showMsg(msg, 'error', 3000);
          }
        }
        return licenseJudge.usable;
        // eslint-disable-next-line no-else-return
      } else {
        try {
          const res = await GetBusinessLicense();
          store.commit('setLicense', res.data.result);
          return store.dispatch('LicenseJudge', { str, msg });
        } catch (error) {
          console.error(error);
        }
      }
    },

    /** MES error msg 翻譯 */
    handleMsgError(_, { preMsg = '', errorMsg = '', msgInfo = '' }) {
      let finalMsg = preMsg || '';
      let matched = false;
      // 定義錯誤類型對應的翻譯鍵
      const errorTypes = [
        { prefix: 'SYSTEM WARNING', key: 'System_warn' },
        { prefix: 'MES', key: 'MES_err' },
        { prefix: 'SPC', key: 'SPC_err' },
        { prefix: 'SYSTEM', key: 'System_err' },
        { prefix: 'DL', key: 'DL_err' },
      ];

      errorTypes.forEach(({ prefix, key }) => {
        const match = errorMsg.match(new RegExp(`\\[${prefix} (\\d+)\\]`));
        if (match) {
          matched = true;
          const code = match[1];
          const translatedMsg = window.$i18n.$t(key)[code] || errorMsg;
          if (errorMsg.includes('WARNING')) {
            showMsg(finalMsg + translatedMsg + msgInfo, 'warning', 3000);
          } else {
            showMsg(finalMsg + translatedMsg + msgInfo, 'error', 3000);
          }
        }
      });
      if (!matched) {
        // 如果都沒有找到，顯示原始錯誤訊息
        showMsg(errorMsg, 'error', 3000);
      }
    },
  },

  getters: {
    getNowUIKey: (state) => {
      return state.nowBUKey;
    },
    getBUlist: (state) => {
      // console.log(state);
      return state.userBUlist;
    },
    // 取得目前選擇的介面的名稱
    // getNowUIName: (state) => {
    //   let buName = state.userBUlist.filter((item) => {
    //     return item.sys_bu === state.nowBUKey;
    //   })[0];
    //   // console.log(state);
    //   // console.log(state.userBUlist);
    //   // console.log(buName);
    //   return buName || '';
    // },
  },
  modules: {
    system,
    dashboard,
    member,
    controlItem,
    settingManagement,
    ocap,
    alertList,
    wip,
  },
});
